<template>
  <v-toolbar v-show="userLogged" fixed flat id="titleBar" :height=40 style="top:60px;">
    <v-spacer/>
    <div v-if="showTitle" style="margin-bottom: -16px; font-size: 20px; position: fixed; left: 26px;">{{ selVessel }}</div>
    <v-select :class="'dateSelect'" dark v-model="select" :label="label" :items="dropDownList" flat primary background-color='rgb(51,82,128)' style="max-width:112px; margin-top:15px; font-size:14px;"/>
    <div v-show="timeStamp" class="timeStamp">{{ timeStamp }}</div>
    <v-dialog v-model="dialog" max-width="300px">
      <v-date-picker v-model="datePicked" color='rgb(51,82,128)' :max="primaryMaxDate" full-width/>
    </v-dialog>
    <v-dialog v-model="alert" max-width="200px">
      <v-alert class='alert' :value="alert" type="info" transition="scale-transition" color='rgb(51,82,128)' outline>
        There is no available data for this date.
      </v-alert>
    </v-dialog>
    <v-dialog v-model="loading" max-width="200px">
      <div style="background-color:white;display:flex;justify-content:center;align-items:center;height:100px;">
        <v-progress-circular indeterminate :size="70" :width="7" color='rgb(51,82,128)' style="background-color:white;"></v-progress-circular>
      </div>
    </v-dialog>
  </v-toolbar>
</template>

<script>
import {globalStore} from "../main.js"
import {getData} from "../getData.js";

var apiService;

export default {
  name: 'Titlebar',
  components: {},
  props: {},
  data() {
    return {
      breadCrumbList: ['Dashboard'],
      dropDownList: ['Last Update', 'Today', 'Select Date'],
      screensForBack: ['Settings', 'Alerts', 'Faults History', 'Report'],
      select: '',
      dialog: false,
      datePicked: '',
      timeStamp: '',
      placeholder: '',
      label: 'Last Update',
      alert: false,
      check: undefined,
      showBreadCrumb: true,
      vesselName: '',
      primaryMaxDate: new Date().toISOString(),
      alertTimer: null,
      created: false
      // primaryMaxDate: ''
    }
  },
  created() {
    apiService = new getData(globalStore.userProfile);

    let name = this.$route.name;

    if (this.screensForBack.includes(name))
      this.showBreadCrumb = false;
    else
      this.showBreadCrumb = true;

    if (this.breadCrumbList.includes(name)) {
      let index = this.breadCrumbList.indexOf(name);

      this.breadCrumbList = this.breadCrumbList.slice(0, index + 1);
    } else {
      this.breadCrumbList.push(name);
    }

    if (
        Object.keys(this.$route.params).indexOf('date') > -1    // Check if parameter exists
        && !!this.$route.params['date']                         // Check if parameter is set
        && !isNaN(Date.parse(this.$route.params['date']))       // Check if parameter is date
    ) {
      this.label = 'Select Date';
      this.datePicked = this.$route.params['date'];

      this.select = this.label;
    } else {
      this.select = 'Last Update';
      this.created = true
    }
  },
  computed: {
    currPath: function () {
      return this.$route.path;
    },
    selVessel: function () {
      return globalStore.selectedVessel;
    },
    userLogged: function () {
      return globalStore.userLogged;
    },
    dataLoaded: function () {
      return globalStore.type;
    },
    checkedDate: function () {
      return globalStore.checkedDate;
    },
    mapDate: function () {
      return globalStore.mapDate;
    },
    showTitle: function () {
      var pages = [
        'Vessel View',
        'Engine Performance',
        'Engine Faults'
      ];

      return pages.indexOf(this.$route.name) >= 0;
    },
    alertDate: function () {
      return globalStore.alertDate;
    },
    twin: function () {
      return globalStore.twinEngine;
    },
    currentRouteName: function () {
      return this.$route.name;
    },
    loading: function () {
      return globalStore.loading;
    },
    selEngine: {
      cache: false,
      get: function () {
        return globalStore.selectedEngine;
      }
    }
  },
  watch: {
    currPath: function () {
      let name = this.$route.name;

      if (this.screensForBack.includes(name))
        this.showBreadCrumb = false;
      else
        this.showBreadCrumb = true;

      if (this.breadCrumbList.includes(name)) {
        let index = this.breadCrumbList.indexOf(name);

        this.breadCrumbList = this.breadCrumbList.slice(0, index + 1);
      } else {
        this.breadCrumbList.push(name);
      }
    },
    select: function (a,b) {
      this.handleSelected();
    },
    selVessel: function () {
      globalStore.loading = true;

      if (this.placeholder == 'Last Update' || this.currentRouteName.toLowerCase() == 'dashboard')
        apiService.getData('last', globalStore.selectedIMO);
      else if (this.placeholder == 'Today')
        apiService.getData('today', globalStore.selectedIMO);
      else
        apiService.getData(this.datePicked, globalStore.selectedIMO);
    },
    mapDate: function () {
      this.datePicked = this.mapDate;
    },
    alertDate: function () {
      globalStore.loading = true;
      this.placeholder = 'Select Date';
      this.datePicked = this.alertDate;
    },
    datePicked: function () {
      apiService.checkDate(this.datePicked, globalStore.selectedIMO);
    },
    dataLoaded: function () {
      if (globalStore.type != '') {
        if ((globalStore.type == 'today') || (globalStore.type == 'last')) {
          let refKeys = Object.keys(globalStore.reference),
              sigKeys = Object.keys(globalStore.signals);

          var temp = ((refKeys.length > sigKeys.length) ? refKeys : sigKeys);

          if (temp.indexOf('average') > -1)
            temp.splice(temp.indexOf('average'), 1);

          this.timeStamp = '';
        } else {
          this.timeStamp = globalStore.type;
        }
      }
    },
    currentRouteName: function () {
      if (this.currentRouteName.toLowerCase() == 'dashboard') {
        this.select = 'Last Update';
      }
    },
    checkedDate(check) {
      if (check) {
        if (globalStore.validDate) {
          if (this.placeholder == 'Select Date') {
            console.log(globalStore.selectedIMO)
            apiService.getData(this.datePicked, globalStore.selectedIMO);
            this.dialog = false;
          } else if (this.placeholder == 'Last Update')
            apiService.getData('last', globalStore.selectedIMO);
          else
            apiService.getData('today', globalStore.selectedIMO);
        } else {
          this.alert = true;
        }
      }
    },
    '$route.name': {
      handler: function (name) {
        if (name == 'Vessel View' && !['today', 'last'].includes(globalStore.type)) {
          this.vesselName = this.$route.params.vessel;

          let refKeys = Object.keys(globalStore.reference).length,
              sigKeys = Object.keys(globalStore.signals).length;

          var temp = ((refKeys.length > sigKeys.length) ? Object.keys(globalStore.signals) : Object.keys(globalStore.reference));

          if (typeof temp != 'undefined' && temp.length) {
            temp = temp.filter((item) => {
              return !isNaN(new Date(parseInt(item)).getTime());
            });

            this.timeStamp = new Date(parseInt(temp[temp.length - 1])).toISOString().substring(0, 10);
          }
        } else {
          this.vesselName = '';
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    handleSelected() {
      if (this.select != '') {
        if (this.select == 'Select Date') {
          if (this.created) {
            this.dialog = true;
          } else {
            this.dialog = false;
          }
        } else {
          if (this.select == 'Last Update')
            apiService.checkDate('last', globalStore.selectedIMO);
          else
            apiService.checkDate('today', globalStore.selectedIMO);
        }

        this.placeholder = this.select;
        this.select = '';
        this.created = true;
      }
    },
    navTo(screen) {
      this.$router.push({name: screen})
    },
    goBack() {
      this.$router.go(-1);
    }
  },
  updated() {
    try {
      clearTimeout(this.alertTimer);
    } catch (e) {}

    this.alertTimer = setTimeout(() => {
      if (globalStore.userLogged) {
        apiService.getUserNotifications();
      }
    }, 250)
  }
}
</script>

<style scoped>
#titleBar {
  background-color: rgb(244, 244, 244);
  padding: 0px;
  font-size: 20px;
  color: rgb(51, 82, 128);
}

.titleBtn {
  color: rgb(51, 82, 128);
  font-size: 10px;
  text-transform: none;
  display: inline-block;
  height: 100%;
}

.timeStamp {
  color: rgb(51, 82, 128);
  font-size: 12px;
  text-transform: none;
  display: flex;
  align-items: center;
  border-style: solid;
  border-color: rgb(51, 82, 128);
  border-width: 1px;
  padding-left: 4px;
  padding-right: 10px;
  height: 32px;
  margin-top: 15px;
  margin-bottom: 8px;
}

.v-input__slot {
  min-height: 20px;
}

.alert {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 250px;
  height: 100px;
  background-color: white;
}
</style>

<style>
.dateSelect .v-select__selection.v-select__selection--comma {
  position: relative;
  left: 8px;
}

.dateSelect .v-select__selections input {
  display: none;
}

.dateSelect .v-label {
  position: absolute !important;
  color: #fff !important;
  font-size: 14px !important;
  line-height: 18px !important;
  left: 8px !important;
}

.dateSelect .v-label.v-label--active {
  display: none !important;
}
</style>
